//#region src/interfaces/AgentConfigurationInterfaces.ts
var e = {
	SEARCH_AGENT: "SEARCH_AGENT",
	CASE_RESOLUTION: "CASE_RESOLUTION"
};
//#endregion
export { e as AGENT_TYPES };

//# sourceMappingURL=AgentConfigurationInterfaces.js.map